import React from 'react';
import type { HeadContentData } from './types';

interface BasicSEOTabProps {
  formData: HeadContentData;
  onInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => void;
}

export const BasicSEOTab: React.FC<BasicSEOTabProps> = ({ formData, onInputChange }) => (
  <div className="space-y-4">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Page Title</label>
      <input
        type="text"
        name="title"
        value={formData.title}
        onChange={onInputChange}
        placeholder="Enter page title (60 characters recommended)"
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
      <p className="text-xs text-gray-500 mt-1">{formData.title.length}/60 characters</p>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Meta Description</label>
      <textarea
        name="description"
        value={formData.description}
        onChange={onInputChange}
        placeholder="Brief description of the page (160 characters recommended)"
        rows={3}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
      <p className="text-xs text-gray-500 mt-1">{formData.description.length}/160 characters</p>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Favicon URL</label>
      <input
        type="url"
        name="favicon"
        value={formData.favicon}
        onChange={onInputChange}
        placeholder="https://example.com/favicon.ico"
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Canonical URL</label>
      <input
        type="url"
        name="canonicalUrl"
        value={formData.canonicalUrl}
        onChange={onInputChange}
        placeholder="https://example.com/page"
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
      <p className="text-xs text-gray-500 mt-1">Leave blank to automatically use the page's URL</p>
    </div>
  </div>
);
